import classNames from "classnames";
import React, { useCallback, useState } from "react";
import { FiMinus, FiPlus } from "react-icons/fi";
import { NumberInputSpinnerProps } from ".";

export const NumberInputSpinner: React.FC<NumberInputSpinnerProps> = ({
  value,
  onDecrement,
  onIncrement,
  decrementLimit = 0,
  incrementLimit = 1000,
  onChangeInput,
  containerStyle,
}) => {
  const [newValue, setNewValue] = useState<number>(value);
  const [decLimit] = useState<number>(decrementLimit);
  const [incLimit] = useState<number>(incrementLimit);

  const handleDecrement = useCallback(() => {
    if (newValue <= decLimit) return;
    const isDecreased = onDecrement();
    if (isDecreased) setNewValue((prev) => prev - 1);
  }, [decLimit, newValue, onDecrement]);

  const handleIncrement = useCallback(() => {
    if (newValue >= incLimit) return;
    const isIncreased = onIncrement();
    if (isIncreased) setNewValue((prev) => prev + 1);
  }, [incLimit, newValue, onIncrement]);

  const handleChangeInput = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (!onChangeInput) return;
      if (e.target.value) {
        onChangeInput(parseInt(e.target.value));
        setNewValue(parseInt(e.target.value));
      } else {
        setNewValue(0);
        onChangeInput(0);
      }
    },
    [onChangeInput]
  );

  return (
    <div
      className="input-group rounded-top rounded-bottom border border-primary"
      style={{ ...containerStyle }}
    >
      <div className="input-group-prepend">
        <div
          onClick={handleDecrement}
          className={classNames("input-group-text bg-white", {
            "cursor-pointer": newValue >= decLimit,
          })}
        >
          <FiMinus
            className={classNames(
              newValue <= decLimit ? "text-secondary-gray" : "border-primary"
            )}
          />
        </div>
      </div>

      <input
        type="text"
        placeholder="0"
        value={newValue}
        pattern="[0-9]{1,5}"
        className={classNames(
          "form-control text-center",
          onChangeInput ? "bg-white" : "bg-gray-100"
        )}
        onChange={handleChangeInput}
        disabled={!onChangeInput}
      />

      <div className="input-group-append">
        <div
          onClick={handleIncrement}
          className={classNames("input-group-text bg-white", {
            "cursor-pointer": newValue <= incLimit,
          })}
        >
          <FiPlus
            style={{
              color:
                newValue >= incLimit ? "text-secondary-gray" : "border-primary",
            }}
          />
        </div>
      </div>
    </div>
  );
};
